import { useState, useEffect, useRef } from "react";
import { useAI } from "../Context/AiContext";
import "./ChatAI.css";
import BotAIImage from "../Assets/images/Bot-ai.jpg";
import { Trans, useTranslation } from "react-i18next";

export default function ChatAI({ botName = "Assistant IA, Alex" }) {
    const { conversation, sendMessage, isLoading, refetch } = useAI();
    const { t } = useTranslation();

    const [input, setInput] = useState("");
    const [open, setOpen] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const scrollRef = useRef(null);
    const [isUserScrolling, setIsUserScrolling] = useState(false);

    // Charger la conversation existante au montage
    useEffect(() => {
        refetch();
    }, [refetch]);

    // Scroll automatique si l'utilisateur n'a pas scrollé manuellement
    useEffect(() => {
        if (scrollRef.current && !isUserScrolling) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [conversation, isUserScrolling, isTyping]);

    const handleSend = async (e) => {
        e.preventDefault();
        if (!input.trim()) return;

        setIsTyping(true);
        await sendMessage(input);
        setInput("");
        setIsTyping(false);
    };

    const handleScroll = () => {
        const scrollElement = scrollRef.current;
        if (!scrollElement) return;

        const atBottom =
            scrollElement.scrollHeight - scrollElement.scrollTop === scrollElement.clientHeight;

        setIsUserScrolling(!atBottom);
    };

    if (isLoading) return <div>Chargement du chat...</div>;

    return (
        <>
            {/* Bouton flottant */}
            {!open && (
                <div className="chat-toggle-button-wrapper" onClick={() => setOpen(true)}>
                    <div className="chat-toggle-button">
                        <img src={BotAIImage} alt="Bot AI" className="chat-toggle-avatar" />
                    </div>
                    <div className="chat-message ai ai-attention">
                        <div className="message-text">
                            <Trans
                                i18nKey="chat.greetingAttention"
                                components={{ 1: <br /> }}
                                values={{ botName }}
                            />
                        </div>
                    </div>
                </div>
            )}

            {/* Chat ouvert */}
            {open && (
                <div className="chat-container floating-chat">
                    <div className="chat-header">
                        <img src={BotAIImage} alt="Bot AI" className="chat-header-avatar" />
                        {botName}
                        <button className="chat-close-button" onClick={() => setOpen(false)}>✖</button>
                    </div>

                    <div className="chat-messages" ref={scrollRef} onScroll={handleScroll}>
                        {/* Message fixe au début */}
                        <div className="chat-message ai">
                            <div className="avatar">
                                <img src={BotAIImage} alt="AI" />
                            </div>
                            <div className="message-text" style={{ backgroundColor: "#4aae9b", color: "#fff" }}>
                                <Trans
                                    i18nKey="chat.greetingFixed"
                                    components={{ 1: <br /> }}
                                    values={{ botName }}
                                />
                            </div>
                        </div>

                        {/* Messages de la conversation */}
                        {conversation.map((msg, idx) => (
                            <div key={idx} className={`chat-message ${msg.role}`}>
                                <div className="avatar">
                                    {msg.role === "ai" ? (
                                        <img src={BotAIImage} alt="AI" />
                                    ) : (
                                        (msg.username || "U").slice(0, 2).toUpperCase()
                                    )}
                                </div>
                                <div
                                    className="message-text"
                                    style={{
                                        backgroundColor: msg.role === "ai" ? "#4aae9b" : "#e0e0e0",
                                        color: msg.role === "ai" ? "#fff" : "#000",
                                    }}
                                >
                                    {msg.message}
                                </div>
                            </div>
                        ))}

                        {/* Bulles "AI typing" */}
                        {isTyping && (
                            <div className="chat-message ai">
                                <div className="avatar">
                                    <img src={BotAIImage} alt="AI" />
                                </div>
                                <div className="message-text ai-typing">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        )}
                    </div>

                    <form className="chat-input" onSubmit={handleSend}>
                        <input
                            type="text"
                            placeholder={t("chat.inputPlaceholder")}
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                        />
                        <button type="submit" disabled={isTyping}>
                            {isTyping ? "..." : "Envoyer"}
                        </button>
                    </form>
                </div>
            )}
        </>
    );
}